import React, { useEffect, useState } from 'react';
import { TiArrowDownThick } from "react-icons/ti";

const Slider = ({ imageUrls, realEstate, academy }) => {
    // autoscroll page to top
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const [imageIndex, setImageIndex] = useState(0);

    const showNextImage = () => {
        setImageIndex(index => {
            if (index === (imageUrls.length - 1)) return 0;
            return index + 1;
        })
    }

    useEffect(() => {
        const interval = setInterval(() => {
            showNextImage();
        }, 8000);
        return () => clearInterval(interval);
    }, [])

    return (
        <div className='slider-container'>
            <div className='slides'>
                {imageUrls.map(url => (
                    <img
                        key={url}
                        src={url}
                        alt={url}
                        className='slider-img'
                        style={{ translate: `${-100 * imageIndex}%` }}
                    />
                ))}
            </div>

            {
                realEstate ? (
                    imageIndex === 0 ? (
                        <div class="slider-caption">
                            <div class="brainytech_homewrapper">
                                <h3 class="wow bounceIn"> We deal in commercial and residential properties  </h3>
                                <h1 class="wow bounce">BRAINYTECH NETWORKS</h1>
                                <h2>
                                    <span class="wow fadeIn" data-wow-delay="0.3s">SALES </span>
                                    <span class="wow fadeIn" data-wow-delay="0.6s">AND </span>
                                    <span class="wow fadeIn" data-wow-delay="0.9s">LEASING </span>
                                    <span class="wow fadeIn" data-wow-delay="1.2s">OF REAL ESTATE </span>
                                </h2>
                                <a href="#body-wrap" class="smoothScroll brainytech-slider-btn btn btn-default">Learn More</a>
                            </div>
                        </div>
                    ) : (
                        <div class="slider-caption">
                            <div class="brainytech_homewrapper">
                                <h2> professionalism & customer satisfaction</h2>
                                <h1>ICT & REAL ESTATE</h1>
                                <h3>Contact us for quality service </h3>

                            </div>
                        </div>
                    )
                ) : (
                    academy ? (<div class="slider-caption">
                        <div class="brainytech_homewrapper">
                            <div >
                                <a href="#body-wrap" class="smoothScroll brainytech-slider-btn btn academy-btn" style={{ backgroundColor: "#55ACEE", opacity: 1, fontWeight: "Bold" }} >
                                    VIEW COURSES
                                    <TiArrowDownThick style={{ marginLeft: "3px", fontSize: "20px", position: "relative", top: "4px" }} />
                                </a>
                            </div>
                        </div>
                    </div>) : (
                        imageIndex === 0 ? (
                            <div className="slider-caption">
                                <div className="brainytech_homewrapper">
                                    <h3 className="wow bounceIn">web design and software development</h3>
                                    <h1 className="wow bounce">BRAINYTECH NETWORKS</h1>
                                    <h2>
                                        <span className="wow fadeIn" data-wow-delay="0.3s">WEB, </span>
                                        <span className="wow fadeIn" data-wow-delay="0.6s">MOBILE, </span>
                                        <span className="wow fadeIn" data-wow-delay="0.9s">UX DESIGN & </span>
                                        <span className="wow fadeIn" data-wow-delay="1.2s">ANIMATION </span>
                                    </h2>
                                    <a href="#portfolio" className="smoothScroll brainytech-slider-btn btn btn-default">Learn More</a>
                                </div>
                            </div>
                        ) : (
                            <div className="slider-caption">
                                <div className="brainytech_homewrapper">
                                    <h2>OFFICE AUTOMATION & SOLUTIONS</h2>
                                    <h1>ICT & REAL ESTATE</h1>
                                    <h3>NETWORKING, COMPUTER EQUIPMENT & ACCESSORIES SUPPLY </h3>
                                    <a href="#about" className="smoothScroll brainytech-slider-btn btn btn-default">Meet Our Team</a>
                                </div>
                            </div>
                        )

                    )
                )}
        </div >
    )
}

export default Slider